import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import { RadioSwatchGroup as CoreRadioSwatchGroup } from '@vds-core/inputs';
import { calculateRem } from '@uie/javascript-style-helpers';
import { BodyConfig, TypographyConfig } from '@vds/typography';
var typescale = TypographyConfig.getTypescale();

function _calculateFocusSize(size) {
  return calculateRem(size + 6);
}

function _determineSwatchMargin() {
  return "".concat(calculateRem(0), " auto ").concat(calculateRem(8));
}

var RadioSwatchGroup = function RadioSwatchGroup(props) {
  return /*#__PURE__*/React.createElement(CoreRadioSwatchGroup, _extends({}, props, {
    bodyConfig: BodyConfig,
    typescale: typescale,
    typographyConfig: TypographyConfig,
    focusSize: _calculateFocusSize,
    focusState: true,
    selectedStateDoubleBorder: true,
    labelMargin: 4,
    labelMaxWidth: 120,
    labelMinWidth: 44,
    swatchMargin: _determineSwatchMargin,
    size: 26,
    disabledState: false
  }));
};

export default RadioSwatchGroup;